<template>
  <div>
    <div class="mt-10 px-5">
      <v-card class="mx-auto ma-5 key-list-card" max-width="700">
        <v-toolbar flat>
          <v-text-field
              outlined
              clearable
              :append-outer-icon="keyword ? 'search':''"
              v-model="keyword"
              label="请输入商品的网页地址，如：https://item.jd.com/xxxxxxxx.html"
              @click:append-outer="send"
              @keydown.enter.prevent="send"
          ></v-text-field>
        </v-toolbar>
      </v-card>
    </div>

    <div>
      <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar>
            <v-btn
                icon
                @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ result.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>


          <div class="pa-5">
            <v-card elevation-5>
              <v-card-title>
                <img class="px-3" :src="result.icon" alt=""/>
                {{ result.from }}
              </v-card-title>
              <v-card-subtitle class="mx-3 my-2">
                <span> 历史最低价: {{ result.lowest }}</span>
              </v-card-subtitle>
              <v-card-text :style="{'height':`${size.height}px`}">
                <div v-if="dialog" class="echarts-class"
                     ref="echarts"></div>
              </v-card-text>
            </v-card>
          </div>
        </v-card>
      </v-dialog>
    </div>

  </div>
</template>

<script>
import {Encrypt} from '@/utils/Aes';
import {getProductHistoricalPrice} from "@/api/resources/product";
import {mapGetters, mapMutations} from "vuex";

export default {
  data: () => ({
    priceCharts: null,
    keyword: undefined,
    dialog: false,
    result: {},
    size: {}
  }),
  computed: {
    ...mapGetters(['getDarker']),
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
  },
  mounted() {
    this.size = {
      height: this.isModel ? this.$vuetify.breakpoint.height - 200 : this.$vuetify.breakpoint.height / 2,
      width: this.$vuetify.breakpoint.width
    }
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    send() {
      if (!this.keyword) return;
      this.setLoading()
      let url = Encrypt(this.keyword);
      getProductHistoricalPrice({encryptStr: url}).then(res => {
        this.result = res.data.data;
        this.dialog = true
        this.$nextTick(() => {
          this.setOptions()
        })
      }).finally(() => {
        this.clearLoading()
      })
    },

    onResize() {
      this.$nextTick(() => {
        if (this.priceCharts) {
          this.priceCharts.resize();
        }
      })
    },

    setOptions() {
      let {times, prices} = this.result
      let option = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        xAxis: {
          type: 'category',
          data: times
        },
        yAxis: {
          type: 'value'
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            restore: {},
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            data: prices,
            type: 'line',
          }
        ]
      };

      this.$nextTick(() => {
        this.priceCharts = this.$echarts.init(this.$refs.echarts, 'vintage', {renderer: 'canvas'});
        this.priceCharts.setOption(option);
        this.priceCharts.resize();
      })
    },
    beforeDestroy() {
      if (typeof window === 'undefined') return

      window.removeEventListener('resize', this.onResize)
    },
  }
}
</script>

<style scoped>
.echarts-class {
  height: 100%;
  width: 100%;
}

.key-list-card {
  z-index: 2;
}
</style>
